
export const projectsData = [
  {
    id: 1,
    image: "/assets/e-learning.jpeg",
    title: "E-learning",
    category: "FullStack",
    video: "/assets/anime.mkv",
  },
  {
    id: 2,
    image: "/assets/furt.png",
    title: "Furniture",
    category: "Collaboration",
    // video: "/assets/anime.mkv",
  },
  {
    id: 3,
    image: "/assets/anime.png",
    title: "Anime",
    category: "Front",
    video: "/assets/anime.mkv",
  },

  {
    id: 4,
    image: "/assets/resteau-img.jpg",
    title: "Restaurant",
    category: "FullStack",
    // video: "/assets/gym_mobile.mp4",
  },
  {
    id: 5,
    image: "/assets/fertinat-img.jpeg",
    title: "Fertinat",
    category: "Front",
    video: "/assets/fertinat.webm",
  },
  {
    id: 6,
    image: "/assets/camping-img.jpg",
    title: "Camping",
    category: "Collaboration",
    video: "/assets/camping.mp4",
  },
  {
    id: 7,
    image: "/assets/youtube-img.jpg",
    title: "Youtube Clone",
    category: "Collaboration",
    video: "/assets/CloneYoutube.mkv",
  },
];

export const projectsNav = [
  {
    name: "All",
  },
  {
    name: "FullStack",
  },
  {
    name: "Front",
  },
  {
    name: "Collaboration",
  },

];

